module.exports = __webpack_public_path__ + "static/media/81aot0jAfFL._AC_SL1500_.9bdda6db.jpg";